var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.visualizarModeloMemorial
        ? _c("app-modal-modelo-memorial", {
            on: { closeModal: _vm.closeModal }
          })
        : _vm._e(),
      _c(
        "el-row",
        { staticClass: "margin-medium-top" },
        [
          _c("app-label", {
            staticClass: "width",
            attrs: { label: "Memorial Descritivo:" }
          }),
          _c(
            "div",
            { staticClass: "buttons-memorial" },
            [
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.openModal } },
                [_c("u", [_vm._v("Modelo")])]
              ),
              _c(
                "el-button",
                { staticClass: "btn", on: { click: _vm.calcularLimites } },
                [_vm._v("Calcular Limites")]
              )
            ],
            1
          ),
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("el-input", {
                      staticClass: "input",
                      class: { erro: errors.length },
                      attrs: { type: "textarea", rows: 10, name: "memorial" },
                      model: {
                        value: _vm.memorialDescritivo,
                        callback: function($$v) {
                          _vm.memorialDescritivo = $$v
                        },
                        expression: "memorialDescritivo"
                      }
                    }),
                    _c("span", { staticClass: "help erro" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("app-limites", {
        staticClass: "app-limites",
        attrs: { limites: _vm.limites },
        on: { changeLimites: _vm.changeLimites }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f13762c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f13762c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/components/AppMemorialDescritivo.vue
// module id = null
// module chunks = 